import { TextField } from "@mui/material";
import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";

type TextInputProps = {
  label: string;
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
  setDisabled?: Dispatch<SetStateAction<boolean>>;
};

export const TextInput = ({
  label,
  value,
  setValue,
  setDisabled = () => {},
}: TextInputProps) => {
  const [error, setError] = useState(value.length === 0);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    setError(e.target.value.length === 0);
    setDisabled(e.target.value.length === 0);
  };

  return (
    <TextField
      required
      label={label}
      name={label}
      value={value}
      onChange={onChange}
      helperText={error && "Required"}
      margin="dense"
    />
  );
};
